import React from 'react';

// Custom imports:
import Admin_errorDialog from './Admin_errorDialog';
import Auth_dialogDialog from './Auth_dialogDialog';
import Auth_termsDialog from './Auth_termsDialog';
import ConfirmationDialog from './ConfirmationDialog';
import InstructionsDialog from './InstructionsDialog';



export const Dialogs = () => {
  return (
    <>
      
			<Admin_errorDialog />
			<Auth_dialogDialog />
			<Auth_termsDialog />
			<ConfirmationDialog />
			<InstructionsDialog />
      
    </>
  );
};

export default Dialogs;
